module.exports = __webpack_public_path__ + "img/smile.d2807acf.svg";